<template>
  <RouterView />
</template>

<style lang="scss">
@import './assets/style/all';
</style>
